module.exports = __webpack_public_path__ + "img/tracery.68bccb34.svg";